import md5 from "md5";

export const shadowString = (str, shadowType = '***') => {
    if (shadowType === 'md5') {
        return md5(str) as string;
    } else if (shadowType === '***') {
        return '***';
    }
    return '';
}
